import { SIMULATION_STEP_SECONDS } from '../timing';

export interface EcosystemConfiguration {
  readonly capacity: number;
  readonly initialPopulation: number;
  readonly fixedStepSeconds: number;
  readonly domainHalfSize: number;
  readonly asteroidCount?: number;
  /** Defaults to true; deterministic trophic tests may isolate natural dynamics. */
  readonly recoveryComets?: boolean;
}

export const FIXED_STEP_SECONDS = SIMULATION_STEP_SECONDS;
/** A sparse founder cohort; populations may grow into the full 32k capacity. */
export const PRIMARY_ENTITY_INITIAL_POPULATION = 400;
export const MAX_PRIMARY_CAPACITY = 32_768;

export function treeDepthForPopulation(count: number): number {
  if (count < 128) {
    return 3;
  }
  if (count < 768) {
    return 4;
  }
  // Life clusters in tiny planetary habitats. A shallow tree leaves most of
  // each habitat in one direct near-field bucket despite a modest total count.
  return count < 14_000 ? 8 : 9;
}
